// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","languageSelectContainer":"Header_languageSelectContainer__t4gtD","languageSelect":"Header_languageSelect__sj5y5"};